<div class="flex-row factor-line">
    <div class="flex-column title-descrip">
        <h4>{{title}}</h4>
        <span>{{description}}</span>
    </div>
    <div class="chip-status">
        <phc-aligned-chip [isAligned]="factorStatus"></phc-aligned-chip>
    </div>
</div>
